import { useEffect, useState } from "react";

// SUBSCRIBED_KEY is set once after any successful subscribe (WhatsApp digest
// or web push). CTAs use useIsSubscribed() to hide themselves once the
// visitor has already joined on this device.
export const SUBSCRIBED_KEY = "ir_is_subscribed";

export const markSubscribed = () => {
  try { localStorage.setItem(SUBSCRIBED_KEY, "1"); } catch (e) { /* ignore */ }
  try { window.dispatchEvent(new Event("ir:subscribed-changed")); } catch (e) { /* ignore */ }
};

export const clearSubscribed = () => {
  try { localStorage.removeItem(SUBSCRIBED_KEY); } catch (e) { /* ignore */ }
  try { window.dispatchEvent(new Event("ir:subscribed-changed")); } catch (e) { /* ignore */ }
};

const readFlag = () => {
  try { return localStorage.getItem(SUBSCRIBED_KEY) === "1"; }
  catch (e) { return false; }
};

export const useIsSubscribed = () => {
  const [is, setIs] = useState(readFlag);
  useEffect(() => {
    const update = () => setIs(readFlag());
    window.addEventListener("storage", update);
    window.addEventListener("ir:subscribed-changed", update);
    return () => {
      window.removeEventListener("storage", update);
      window.removeEventListener("ir:subscribed-changed", update);
    };
  }, []);
  return is;
};
